import Highcharts from 'highcharts'

import { GlobalHighchartOptions, GlobalHighchartsStyleOptions } from './HighchartsOptions'

require('highcharts/highcharts-more')(Highcharts)
require('highcharts/modules/bullet')(Highcharts)
require('highcharts/modules/drilldown')(Highcharts)
require('highcharts/modules/solid-gauge')(Highcharts)
// require('highcharts/indicators/indicators')(Highcharts)
// require('highcharts/indicators/pivot-points')(Highcharts)
// require('highcharts/indicators/macd')(Highcharts)
// require('highcharts/modules/exporting')(Highcharts);
// require('highcharts/modules/map')(Highcharts)

const HighchartsInit = () => {
    // Apply Global Options
    Highcharts.setOptions(GlobalHighchartOptions)

    // Apply the theme
    Highcharts.setOptions(GlobalHighchartsStyleOptions)
}

export default HighchartsInit
